<template>
  <div style="padding-bottom: 80px">
    <div class="topbanner">
      <div class="EC_width display_column_between height_100">
        <div></div>
        <div class="text_right">
          <span class="signBlock">
            <img src="image/jigou/fangzi.png"
                 class="marginTop40">
            <p class="signTitle marginTop20">入驻机构</p>
            <span class="signLine"></span>
          </span>
        </div>
      </div>
    </div>
    <div class="EC_width">
      <div class="border_bottom_18  marginTop40 marginBottom20">
        <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
          线上参观
        </div>
      </div>
      <div class="display_flex">
        <div class="Swiperbanner">
          <div class="swiperTaggle">
            <span class="stItem"
                  :class="{stItemActive:tagBannerindex==0}"
                  @click="tagBanner(0)">
              <img src="/image/jigou/tag1.png"
                   alt="">
            </span>
            <span class="stItem"
                  :class="{stItemActive:tagBannerindex==1}"
                  @click="tagBanner(1)">
              <img src="/image/jigou/tag2.png"
                   alt="">
            </span>
            <span class="stItem">
              <img src="/image/jigou/tag3.png"
                   alt="">
            </span>
          </div>
          <div class="videoSet"
               v-if="tagBannerindex==1">
            <img src="/image/jigou/videoimg.png"
                 alt="">
          </div>

          <swiper :options="swiperTop"
                  v-if="tagBannerindex==0"
                  ref="swiperTop"
                  class="gallery-top">
            <swiper-slide v-for="(item,index) in apiData.swiperBanner"
                          :key="index">
              <div style="height: 100%;width: 100%">
                <img :src="item.img"
                     alt=""
                     style="width: 100%">
              </div>
            </swiper-slide>
          </swiper>
          <div v-if="tagBannerindex==0"
               style="position: relative;height: 20%">
            <swiper :options="swiperThumbs"
                    ref="swiperThumbs"
                    class="gallery-thumbs">
              <swiper-slide v-for="(item,index) in apiData.swiperBanner"
                            :key="index">
                <div style="height: 100%;width: 100%;overflow: hidden">
                  <img :src="item.img"
                       alt=""
                       style="width: 100%">
                </div>
              </swiper-slide>
            </swiper>
            <div class="blocknext">&gt;</div>
            <div class="blockpre">&lt;</div>
          </div>

          <!--<div class="swiper-container gallery-thumbs">-->
          <!--<div class="swiper-wrapper">-->
          <!--<div class="swiper-slide" style="background-image:url(image/jigou/detailBanner.png)"></div>-->
          <!--<div class="swiper-slide" style="background-image:url(image/jigou/detailBanner.png)"></div>-->
          <!--<div class="swiper-slide" style="background-image:url(image/jigou/detailBanner.png)"></div>-->
          <!--<div class="swiper-slide" style="background-image:url(image/jigou/detailBanner.png)"></div>-->
          <!--<div class="swiper-slide" style="background-image:url(image/jigou/detailBanner.png)"></div>-->
          <!--<div class="swiper-slide" style="background-image:url(image/jigou/detailBanner.png)"></div>-->
          <!--</div>-->
          <!--<div class="blocknext">&gt;</div>-->
          <!--<div class="blockpre">&lt;</div>-->
          <!--</div>-->
        </div>
        <div class="contentText">
          <p class="cTitle">{{apiData.bannerText.title}}</p>
          <span class="lineSplit"></span>
          <p class="cText">
            {{apiData.bannerText.content}}
          </p>
        </div>
      </div>
      <div class="border_bottom_18  marginTop40 marginBottom20 display_between">
        <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
          机构课程
        </div>
        <div>
          <a href="javascript:;"
             class="gl_pad_btn gl_pad_btn_active marginRight10">技能</a>
          <a href="javascript:;"
             class="gl_pad_btn marginRight10">管理</a>
          <a href="javascript:;"
             class="gl_pad_btn marginRight10">中医</a>
        </div>
      </div>
      <swiper :options="swiperColumn"
              style="padding-bottom: 40px">
        <swiper-slide v-for="(item,index) in apiData.course"
                      :key="index"
                      style="margin-bottom: 10px">
          <div class="pub_square"
               style="margin-bottom: 10px">
            <div class="pubs_img">
              <img :src="item.img">
            </div>
            <div class="pubs_body">
              <div class="pubs_title">
                {{item.title}}
              </div>
              <div class="pubs_label display_between">
                <div>
                  <span v-for="(itemx,indexx) in item.sign"
                        :key="indexx">{{itemx}}</span>
                </div>
                <div class="pubs_cancel">
                  取消收藏
                </div>
              </div>
              <div class="display_between">
                <div class="pubs_tip">
                  <span class="redColor">{{item.price}}</span>
                </div>
                <div class="pubs_rentou">
                  <img src="/image/geren/ren.png">{{item.num}}人
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"
             slot="pagination"></div>
      </swiper>
    </div>
    <div class="grayBlock">
      <div class="EC_width">
        <div class="border_bottom_18  marginTop40 marginBottom20">
          <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
            机构项目
          </div>
        </div>
        <div class="positionBtn">
          <swiper :options="swipertext"
                  ref="swipertext"
                  @slideChangeTransitionEnd="slideChange($event)">
            <swiper-slide v-for="(item,index) in apiData.project"
                          :key="index">
              <a href="javascript:;"
                 class="mediaImg">
                <p class="SwiperTitle">{{item.title}}</p>
                <p class="SwiperText">{{item.intro}}</p>
                <p class="SwiperText">{{item.date}}</p>
              </a>
            </swiper-slide>
          </swiper>
          <div class="prevbutton2">&lt;</div>
          <div class="nextbutton2">&gt;</div>
          <div class="scrolllist"
               v-if="tagglelist">
            <div class="useScroll">
              <img src="/image/jigou/topsImg.png"
                   alt=""
                   class="topsImg">
              <div class="display_between"
                   v-for="(item,index) in newslist"
                   :key="index">
                <div class="newslist">{{item[0].title}}</div>
                <div class="newslist">{{item[1].title}}</div>
              </div>
            </div>
          </div>
          <div class="modal"
               v-if="tagglelist"
               @click="tagglelist=false">

          </div>
        </div>

        <div class="border_bottom_18  marginTop40 marginBottom20 display_between">
          <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
            我的机构课程
          </div>
          <div>

          </div>
        </div>
        <div class="display_between">
          <div class="gl_title_vertical_line gl_title_v_line_active"
               style="border-left-width: 2px;">
            <span style="color: #0B8485;"
                  class="fontBold fontsize14">{{apiData.myCourse.title}}</span><br>
            <span class="fontBold fontsize14">{{apiData.myCourse.project}}</span> /
            <span class="fontsize14">{{apiData.myCourse.date}}</span>
          </div>
          <div>
            <a href="javascript:;"
               class="gl_pad_btn gl_pad_btn_active marginRight10">学分信息补充（已提交）</a>
            <a href="javascript:;"
               class="gl_pad_btn gl_pad_btn_active marginRight10"
               style="background: #B70009;">学分查询</a>
            <span class="marginRight10">更多</span>
          </div>
        </div>
        <div class="display_between marginTop20"
             v-for="(item,index) in myCourselist"
             :key="index">
          <div class="pub_square"
               v-for="(itemn,indexn) in item"
               :key="indexn">
            <div class="pubs_img">
              <img :src="itemn.img">
            </div>
            <div class="pubs_body">
              <div class="pubs_title">
                {{itemn.title}}
              </div>
              <div class="pubs_progess">
                <div class="pubs_progess_active"
                     :style="{width:itemn.progress}">

                </div>
              </div>
              <div class="display_between">
                <div class="pubs_tip">
                  <span>已学</span>
                  <span class="normalColor">{{itemn.progress}}</span>
                </div>
                <div class="pubs_date">
                  {{itemn.date}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="EC_width">
      <div class="border_bottom_18  marginTop40 marginBottom20">
        <div class="gl_title_vertical_line gl_title_v_line_active fontBold">
          我的Link
        </div>
      </div>
      <div class="positionBtn EC_width">
        <swiper :options="swiperlink">
          <swiper-slide v-for="(item,index) in apiData.mylink"
                        :key="index">
            <a href="javascript:;"
               class="linkmedia">
              <img :src="item.img">
              <p>{{item.title}}</p>
            </a>
          </swiper-slide>
        </swiper>
        <div class="prevbutton2">&lt;</div>
        <div class="nextbutton2">&gt;</div>
      </div>
    </div>

  </div>
</template>

<script>
import lodash from "lodash"
export default {
  name: "mechanismDetail",
  computed: {
    swipercenter () {
      return this.$refs.swipertext.swiper
    }
  },
  data () {
    return {
      tagglelist: false,
      apiData: "",
      newslist: "",
      tagBannerindex: 0,
      myCourselist: [],
      swiperThumbs: {
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true
      },
      swiperTop: {
        spaceBetween: 10,
        navigation: {
          nextEl: '.blocknext',
          prevEl: '.blockpre',
          disabledClass: 'my-button-disabled',
        },
      },
      swipertext: {
        loopedSlides: 5,
        loop: true,
        slidesPerView: 4,
        spaceBetween: 10,
        slideActiveClass: 'my-slide-active',
        slideToClickedSlide: true,
        centeredSlides: true,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton2',
          prevEl: '.prevbutton2',
          disabledClass: 'my-button-disabled',
        },
      },
      swiperColumn: {
        slidesPerView: 4,
        slidesPerColumn: 2,
        slidesPerColumnFill: 'row',
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite2',
          bulletActiveClass: 'bulletWriteActive2',
        },
      },
      swiperlink: {
        slidesPerView: 6,
        slidesPerGroup: 1,
        spaceBetween: 10,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.nextbutton2',
          prevEl: '.prevbutton2',
          disabledClass: 'my-button-disabled',
        },
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper
      const swiperThumbs = this.$refs.swiperThumbs.swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
    this.getData()
  },
  methods: {
    tagBanner (index) {
      this.tagBannerindex = index
    },
    slideChange () {
      this.tagglelist = true
    },
    getData () {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        that.apiData = data.mechanismDetail;
        var usemyCourselist = data.mechanismDetail.myCourse.list;
        var usenewslist = data.mechanismDetail.newslist;
        this.myCourselist = lodash.chunk(usemyCourselist, 4);
        this.newslist = lodash.chunk(usenewslist, 4);
      })
    }
  }
}
</script>

<style scoped>
.wrap {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 60px;
}
.qk_head {
    height: 77px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.pub_left_logo {
    width: 420px;
}

.pub_center_menu {
    flex: 1;
    height: 100%;
}

.pub_menu {
    list-style: none;
    padding: 0;
    margin: 0;
    overflow: hidden;
    height: 100%;
}

.pub_menu li {
    float: left;
    height: 100%;
    line-height: 77px;
}

.pub_menu li a {
    padding: 0 20px;
}

.pub_menu_active a {
    color: #0b8686;
}
.videoSet {
    width: 670px;
    height: 378px;
    overflow: hidden;
}
.pub_right_opra {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.inputRelative {
    position: relative;
    display: inline-block;
}

.pub_head_bar_search {
    width: 200px;
    height: 24px;
    box-sizing: border-box;
    border-radius: 24px;
    outline: none;
    border: 1px solid #ddd;
    padding-left: 12px;
}

.inputRelative img {
    position: absolute;
    right: 11px;
    top: 3px;
    cursor: pointer;
}

.pub_mes_img {
    margin: 0 20px;
}

.pub_bar_headimg {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 24px;
    overflow: hidden;
    line-height: 24px;
    text-align: center;
    border: 1px solid #ddd;
}

/* 面包屑导航 */
.breadcrumb_wrap {
    min-width: 1300px;
    list-style: none;
    height: 40px;
    background: #f2f2f2;
    display: flex;
}
.set_breadcrumb {
    list-style: none;
    line-height: 40px;
    height: 100%;
    padding: 0;
}
.set_breadcrumb li {
    display: inline-block;
    font-size: 12px;
    color: #0b8485;
}
.set_breadcrumb li ~ li:before {
    content: '>';
    margin-left: 4px;
    margin-right: 4px;
    color: #333;
}
.set_breadcrumb li a {
    display: inline-block;
    font-size: 12px;
    color: #333;
}
.breadcrumb_search input {
    width: 200px;
    height: 30px;
    box-sizing: border-box;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    outline: none;
    border: 1px solid #f2f2f2;
    padding-left: 10px;
}
.ArrIcon {
    display: inline-block;
    width: 50px;
    height: 30px;
    background: #0b8686;
    border-radius: 0 30px 30px 0;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
}
.blocknext,
.blockpre {
    display: inline-block;
    width: 16px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    box-sizing: border-box;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 10px;
    z-index: 10;
    cursor: pointer;
    outline: none;
}
.blocknext {
    right: 0;
}
.blockpre {
    left: 0;
}
/* 轮播按钮 */
.nextbutton,
.prevbutton,
.nextbutton2,
.prevbutton2 {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: #0b8586;
    color: #fff;
    position: absolute;
    top: 40%;
    z-index: 10;
    cursor: pointer;
    outline: none;
}
.nextbutton2,
.prevbutton2 {
    top: 40%;
}
.nextbutton,
.nextbutton2 {
    right: -30px;
    left: auto;
}

.prevbutton,
.prevbutton2 {
    right: auto;
    left: -30px;
}

.my-button-disabled {
    background: #ddd;
    color: #999;
}
.topbanner {
    height: 400px;
    width: 100%;
    background: url(/image/jigou/banner.png) center no-repeat;
}
.signBlock {
    width: 284px;
    height: 251px;
    background: #0b8586;
    opacity: 0.95;
    border-radius: 10px 10px 0px 0px;
    display: inline-block;
    text-align: center;
}
.signTitle {
    color: #fff;
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 28px;
}
.signLine {
    display: inline-block;
    margin-top: 30px;
    width: 43px;
    height: 1px;
    background: #ffffff;
}
.grayBlock {
    background: #f6f7fb;
    padding: 40px 0;
}
.contentText {
    flex: 1;
    height: 350px;
    overflow-y: auto;
    margin-left: 63px;
    padding-right: 63px;
}

/* 轮播宽度 */
.positionBtn {
    margin-top: 20px;
    position: relative;
    width: 1300px;
}

.contentText::-webkit-scrollbar {
    width: 5px;
    background: #eeeeee;
}

/* 滚动槽 */
.contentText::-webkit-scrollbar-track {
    border-radius: 10px;
}

/* 滚动条滑块 */
.contentText::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #0b8586;
}

.contentText::-webkit-scrollbar-thumb:window-inactive {
    background: #0b8586;
}

.cTitle {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 28px;
}

.lineSplit {
    display: inline-block;
    width: 50px;
    height: 1px;
    background: #0b8485;
}

.Swiperbanner {
    width: 670px;
    height: 350px;
    position: relative;
}
.swiperTaggle {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
}
.stItem {
    display: inline-block;
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 46px;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
}
.stItemActive {
    background: #107c81;
}
.cText {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 28px;
}

/*.gallery-top,*/
/*.gallery-thumbs {*/
/*width: 100%;*/
/*height: 300px;*/
/*margin-left: auto;*/
/*margin-right: auto;*/
/*}*/

.swiper-slide {
    background-size: cover;
    background-position: center;
}

.gallery-top {
    height: 80%;
    width: 100%;
}

.gallery-thumbs {
    height: 100%;
    box-sizing: border-box;
    padding: 10px 0;
}

.gallery-thumbs .swiper-slide {
    height: 100%;
    opacity: 0.4;
}

.gallery-thumbs .swiper-slide-thumb-active {
    opacity: 1;
}

.mediaImg {
    display: inline-block;
    width: 285px;
    height: 190px;
    box-sizing: border-box;
    padding: 30px;
    background: #fff;
}

.SwiperTitle {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 28px;
    margin-bottom: 10px;
}

.SwiperText {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 28px;
}

.swiper-slide {
    text-align: center;
}
.my-slide-active .mediaImg {
    background: #ffffff;
    border: 1px solid #007380;
    box-shadow: 8px 13px 30px 0px rgba(0, 99, 110, 0.3);
}
.my-slide-active .SwiperTitle {
    color: #007380;
}
.gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
    opacity: 1;
}
.linkmedia {
    text-align: center;
    display: block;
}
.linkmedia p {
    margin-top: 10px;
}
.scrolllist {
    position: absolute;
    top: 210px;
    left: 0;
    width: 100%;
    height: 207px;
    background: #fff;
    z-index: 100;
}
.useScroll {
    overflow-y: auto;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    position: relative;
    padding: 50px 150px 50px 50px;
}
.useScroll::-webkit-scrollbar {
    width: 5px;
    background: transparent;
}

/* 滚动槽 */
.useScroll::-webkit-scrollbar-track {
    border-radius: 10px;
}

/* 滚动条滑块 */
.useScroll::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #007380;
}

.useScroll::-webkit-scrollbar-thumb:window-inactive {
    background: #0b8586;
}
.topsImg {
    position: absolute;
    top: -15px;
    left: 50%;
    z-index: 120;
}
.newslist {
    line-height: 30px;
    width: 50%;
}
.newslist:hover {
    color: #007380;
    text-decoration: underline;
    cursor: pointer;
}
.newslist:before {
    content: '';
    border-radius: 10px;
    width: 5px;
    height: 5px;
    background: #000f15;
}
.modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
}
</style>
